import {
  PRODUCT_FEEDBACK_APP_VERSION,
  PRODUCT_FEEDBACK_LIMITS,
  type ProductFeedbackRuntimeSnapshot,
} from '../types/productFeedback';

const EXACT_ELIGIBLE_ROUTES = new Set(['/map', '/list', '/community', '/bezpieczenstwo']);

export const isProductFeedbackEligiblePath = (pathname: string): boolean => {
  if (EXACT_ELIGIBLE_ROUTES.has(pathname)) return true;
  if (pathname === '/app' || pathname.startsWith('/app/')) return true;
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return true;
  return /^\/service-provider\/[^/]+$/.test(pathname);
};

export const isProductFeedbackMapHost = (pathname: string): boolean =>
  pathname === '/map' || pathname === '/app' || pathname === '/app/discover';

export const isProductFeedbackRequestComposerHost = (pathname: string): boolean => {
  const match = pathname.match(/^\/app\/request\/([^/]+)$/);
  return Boolean(match && match[1] !== 'new');
};

const limitRuntimeLabel = (value: string | null | undefined): string | null =>
  value ? value.slice(0, PRODUCT_FEEDBACK_LIMITS.maxRuntimeLabelCharacters) : null;

export const captureProductFeedbackRuntime = (
  pathname: string
): ProductFeedbackRuntimeSnapshot => ({
  capturedAtClient: new Date().toISOString(),
  routePath: pathname.slice(0, PRODUCT_FEEDBACK_LIMITS.maxRouteCharacters),
  viewport: {
    width: window.innerWidth,
    height: window.innerHeight,
    visualWidth: window.visualViewport?.width,
    visualHeight: window.visualViewport?.height,
    devicePixelRatio: window.devicePixelRatio || 1,
  },
  userAgent: limitRuntimeLabel(window.navigator.userAgent),
  platform: limitRuntimeLabel(window.navigator.platform),
  appVersion: PRODUCT_FEEDBACK_APP_VERSION,
  online: window.navigator.onLine,
});

export const createProductFeedbackClientRequestId = (): string => {
  const cryptoApi = globalThis.crypto;
  if (typeof cryptoApi?.randomUUID === 'function') {
    return cryptoApi.randomUUID().replace(/-/g, '_');
  }
  const bytes = new Uint8Array(18);
  if (typeof cryptoApi?.getRandomValues === 'function') {
    cryptoApi.getRandomValues(bytes);
    return `pf_${Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')}`;
  }
  return `pf_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 14)}`;
};
